import React from "react";
import '../css/Responsive.css';
import '../css/App.css';

export default function Footer(){
    return(
        <div className="foot">
            <p>all rights are reserved @eduSolution 2021</p>
            <a href="abc">privacy</a>
            <a href="abc">terms</a>
        </div>
    )
}